import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100",
  style: {"background":"#fff"}
}
const _hoisted_2 = {
  class: "",
  style: {}
}
const _hoisted_3 = {
  class: "circle_button skyblueBg whiteColor mt20 fw600 mb20",
  style: {"height":"50px","width":"400px","padding":"15px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.buttonName)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.buttonName), 1),
          _hoisted_4
        ]),
        _hoisted_5
      ]))
    : _createCommentVNode("", true)
}